import actions from './actions';
import selectors from './store/sliceSelectors';

const UI: UIDomain.UIDomain = {
	actions: actions,
	selectors: selectors
};

export default UI;
